/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaTargetGroup } from './CriteriaTargetGroup';
import {
    CriteriaTargetGroupFromJSON,
    CriteriaTargetGroupFromJSONTyped,
    CriteriaTargetGroupToJSON,
    CriteriaTargetGroupToJSONTyped,
} from './CriteriaTargetGroup';

/**
 * 
 * @export
 * @interface FindAllCriteriaTargets200Response
 */
export interface FindAllCriteriaTargets200Response {
    /**
     * 
     */
    data?: Array<CriteriaTargetGroup>;
}

/**
 * Check if a given object implements the FindAllCriteriaTargets200Response interface.
 */
export function instanceOfFindAllCriteriaTargets200Response(value: object): value is FindAllCriteriaTargets200Response {
    return true;
}

export function FindAllCriteriaTargets200ResponseFromJSON(json: any): FindAllCriteriaTargets200Response {
    return FindAllCriteriaTargets200ResponseFromJSONTyped(json, false);
}

export function FindAllCriteriaTargets200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCriteriaTargets200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CriteriaTargetGroupFromJSON)),
    };
}

export function FindAllCriteriaTargets200ResponseToJSON(json: any): FindAllCriteriaTargets200Response {
    return FindAllCriteriaTargets200ResponseToJSONTyped(json, false);
}

export function FindAllCriteriaTargets200ResponseToJSONTyped(value?: FindAllCriteriaTargets200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CriteriaTargetGroupToJSON)),
    };
}

